// import React, { useState, useEffect } from 'react';
// import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
// import { addDoc, collection, deleteDoc, doc, getDocs } from 'firebase/firestore';
// import { auth, db } from '../../../components/firebase';
// import Tabs from '../../../components/Tabs';
// import { 
//   FaFilePdf, 
//   FaYoutube, 
//   FaGoogleDrive, 
//   FaTrash, 
//   FaSignInAlt, 
//   FaTimes, 
//   FaChevronLeft, 
//   FaChevronRight,
//   FaWhatsapp,
//   FaCopy,
//   FaDownload,
//   FaUpload,
//   FaExternalLinkAlt
// } from 'react-icons/fa';
// import { motion, AnimatePresence } from 'framer-motion';
// import Accordions from '../../../components/Dropdowns';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import PdfViewerModal from './PdfViewerModal';
// import PdfCards from './PdfCards';
// import VideoSection from './VideoSection';
// import UploadForm from './UploadForm';

// const SubjectPage = ({ 
//   subjectName,
//   subjectKey,
//   accordionContent,
//   tabData,
//   adminEmail,
//   firestoreCollections = {} 
// }) => {
//   // Create collection names based on subjectKey
//   const notesCollection = firestoreCollections.notes || `${subjectKey}-notes`;
//   const videosCollection = firestoreCollections.videos || `${subjectKey}-videos`;

//   const [user, setUser] = useState(null);
//   const [notes, setNotes] = useState([]);
//   const [videos, setVideos] = useState([]);
//   const [videoTitle, setVideoTitle] = useState('');
//   const [videoUrl, setVideoUrl] = useState('');
//   const [driveLink, setDriveLink] = useState('');
//   const [driveTitle, setDriveTitle] = useState('');
//   const [pdfModal, setPdfModal] = useState({
//     isOpen: false,
//     currentIndex: 0,
//     category: null
//   });
//   const [showUploadForm, setShowUploadForm] = useState(false);

//   const uploadFormLink = "https://forms.gle/7xrdusY7ePDNYpJ6A";

//   // Helper function to extract file ID from Google Drive URLs
//   const extractFileId = (url) => {
//     const patterns = [
//       /\/file\/d\/([^\/]+)/,
//       /\/d\/([^\/]+)/,
//       /id=([^&]+)/,
//       /\/folders\/([^\/]+)/,
//       /[-\w]{25,}/
//     ];

//     for (const pattern of patterns) {
//       const match = url.match(pattern);
//       if (match && match[1]) {
//         return match[1];
//       }
//     }
//     return url;
//   };

//   useEffect(() => {
//     // Check if there's a PDF or Video ID in the URL when the component loads
//     const urlParams = new URLSearchParams(window.location.search);
//     const pdfId = urlParams.get('pdf');
//     const videoId = urlParams.get('video');

//     if (pdfId) {
//       // Find the note with this ID
//       const note = notes.find(n => n.id === pdfId);
//       if (note) {
//         // Find its category and index
//         const category = note.category;
//         const filteredNotes = notes.filter(n => n.category === category);
//         const index = filteredNotes.findIndex(n => n.id === pdfId);

//         if (index !== -1) {
//           // Open the modal for this PDF
//           setPdfModal({
//             isOpen: true,
//             currentIndex: index,
//             category: category
//           });

//           // Clean up the URL
//           window.history.replaceState({}, document.title, window.location.pathname);
//         }
//       }
//     } else if (videoId) {
//       // Scroll to videos section and highlight the video
//       const videosTab = document.getElementById('youtube_playlist');
//       if (videosTab) {
//         videosTab.click();
//         setTimeout(() => {
//           const videoElement = document.getElementById(`video-${videoId}`);
//           if (videoElement) {
//             videoElement.scrollIntoView({ behavior: 'smooth' });
//             videoElement.classList.add('ring-2', 'ring-green-500');
//             setTimeout(() => {
//               videoElement.classList.remove('ring-2', 'ring-green-500');
//             }, 3000);
//           }
//         }, 500);
//       }
//     }
//   }, [notes, videos]);

//   // Fetch notes from Firestore
//   useEffect(() => {
//     const fetchNotesFromFirestore = async () => {
//       const notesSnapshot = await getDocs(collection(db, notesCollection));
//       setNotes(notesSnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
//     };
//     fetchNotesFromFirestore();
//   }, [notesCollection]);

//   // Fetch videos from Firestore
//   useEffect(() => {
//     const fetchVideos = async () => {
//       const videoCollection = collection(db, videosCollection);
//       const videoSnapshot = await getDocs(videoCollection);
//       setVideos(videoSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
//     };
//     fetchVideos();
//   }, [videosCollection]);

//   // Monitor user authentication state
//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       setUser(user);
//     });
//     return () => unsubscribe();
//   }, []);

//   // Open PDF modal and set current index
//   const openPdfModal = (category, index) => {
//     setPdfModal({
//       isOpen: true,
//       currentIndex: index,
//       category: category
//     });
//   };

//   // Navigate between PDFs in the modal
//   const navigatePdf = (direction) => {
//     const filteredNotes = notes.filter((note) => note.category === pdfModal.category);
//     let newIndex;

//     if (direction === 'prev') {
//       newIndex = pdfModal.currentIndex === 0 ? filteredNotes.length - 1 : pdfModal.currentIndex - 1;
//     } else {
//       newIndex = pdfModal.currentIndex === filteredNotes.length - 1 ? 0 : pdfModal.currentIndex + 1;
//     }

//     setPdfModal(prev => ({
//       ...prev,
//       currentIndex: newIndex
//     }));
//   };

//   // Close PDF modal
//   const closePdfModal = () => {
//     setPdfModal({
//       isOpen: false,
//       currentIndex: 0,
//       category: null
//     });
//   };

//   // Google Sign-In
//   const handleGoogleLogin = async () => {
//     const provider = new GoogleAuthProvider();
//     try {
//       const result = await signInWithPopup(auth, provider);
//       setUser(result.user);
//     } catch (error) {
//       console.error('Error during Google login:', error);
//     }
//   };

//   // File upload handler
//   const handleDriveLinkUpload = (category) => {
//     if (!driveLink || !driveTitle) {
//       alert('Please provide both a valid title and Google Drive link.');
//       return;
//     }

//     // Validate Google Drive link
//     const fileId = extractFileId(driveLink);
//     if (!fileId) {
//       alert('Please provide a valid Google Drive link');
//       return;
//     }

//     const newNote = { 
//       title: driveTitle, 
//       category, 
//       link: `https://drive.google.com/file/d/${fileId}/view?usp=sharing`,
//       directPreviewLink: `https://drive.google.com/file/d/${fileId}/preview`
//     };

//     addDoc(collection(db, notesCollection), newNote).then((docRef) => {
//       setNotes((prevNotes) => [...prevNotes, { ...newNote, id: docRef.id }]);
//       toast.success('Google Drive link uploaded successfully!');
//       setDriveLink('');
//       setDriveTitle('');
//     }).catch(error => {
//       console.error('Error uploading document: ', error);
//       toast.error('Error uploading document. Please try again.');
//     });
//   };

//   // Handle deleting a note
//   const handleDeleteNote = async (note) => {
//     if (window.confirm('Are you sure you want to delete this note?')) {
//       try {
//         const noteDoc = doc(db, notesCollection, note.id);
//         await deleteDoc(noteDoc);
//         setNotes(notes.filter((n) => n.id !== note.id));

//         // Close modal if currently viewing the deleted note
//         if (pdfModal.isOpen && pdfModal.currentNoteId === note.id) {
//           closePdfModal();
//         }
//         toast.success('Note deleted successfully');
//       } catch (error) {
//         console.error('Error deleting document: ', error);
//         toast.error('Error deleting document. Please try again.');
//       }
//     }
//   };

//   // Handle adding a video
//   const handleAddVideo = async () => {
//     if (!videoTitle || !videoUrl) {
//       toast.warning('Please provide both a valid title and video URL.');
//       return;
//     }

//     let formattedUrl = '';
//     if (videoUrl.includes('youtube.com/live')) {
//       const videoId = videoUrl.split('/').pop();
//       formattedUrl = `https://www.youtube.com/embed/${videoId}`;
//     } else if (videoUrl.includes('youtube.com/watch?v=')) {
//       const videoId = new URL(videoUrl).searchParams.get('v');
//       formattedUrl = `https://www.youtube.com/embed/${videoId}`;
//     } else if (videoUrl.includes('youtube.com/playlist?list=')) {
//       const playlistId = new URL(videoUrl).searchParams.get('list');
//       formattedUrl = `https://www.youtube.com/embed/videoseries?list=${playlistId}`;
//     } else {
//       toast.warning('Please provide a valid YouTube video, live stream, or playlist URL.');
//       return;
//     }

//     try {
//       const newVideo = { title: videoTitle, link: formattedUrl };
//       const videoRef = await addDoc(collection(db, videosCollection), newVideo);
//       setVideos((prevVideos) => [...prevVideos, { id: videoRef.id, ...newVideo }]);
//       setVideoTitle('');
//       setVideoUrl('');
//       toast.success('Video added successfully!');
//     } catch (error) {
//       console.error('Error adding video: ', error);
//       toast.error('Error adding video. Please try again.');
//     }
//   };

//   // Handle deleting a video
//   const handleDeleteVideo = async (videoId) => {
//     if (window.confirm('Are you sure you want to delete this video?')) {
//       try {
//         const videoDoc = doc(db, videosCollection, videoId);
//         await deleteDoc(videoDoc);
//         setVideos(videos.filter((video) => video.id !== videoId));
//         toast.success('Video deleted successfully');
//       } catch (error) {
//         console.error('Error deleting video: ', error);
//         toast.error('Error deleting video. Please try again.');
//       }
//     }
//   };

//   // Render upload button with Google Drive link input
//   const renderUploadButton = (category) => (
//     <motion.div 
//       className="mb-8"
//       initial={{ opacity: 0, y: -20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.3 }}
//     >
//       {user?.email === adminEmail && (
//         <div className="flex flex-wrap gap-4 items-center mb-6">
//           <input
//             type="text"
//             placeholder="Note Title"
//             value={driveTitle}
//             onChange={(e) => setDriveTitle(e.target.value)}
//             className="flex-1 min-w-[200px] p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
//           />
//           <input
//             type="text"
//             placeholder="Google Drive Link"
//             value={driveLink}
//             onChange={(e) => setDriveLink(e.target.value)}
//             className="flex-1 min-w-[200px] p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
//           />
//           <motion.button 
//             onClick={() => handleDriveLinkUpload(category)}
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
//           >
//             <FaGoogleDrive /> Upload Link
//           </motion.button>
//         </div>
//       )}
//     </motion.div>
//   );

//   // Render empty state with upload option
//   const renderEmptyState = (category) => (
//     <motion.div 
//       className="flex flex-col items-center justify-center gap-4 p-8 text-gray-500"
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 0.5 }}
//     >
//       <FaFilePdf size={48} className="text-gray-300" />
//       <p className="text-lg">No {category} uploaded yet</p>

//       <div className="flex flex-col sm:flex-row gap-4 mt-4">
//         {user?.email === adminEmail ? (
//           <>
//             <motion.button
//               onClick={() => setShowUploadForm(true)}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
//             >
//               <FaUpload /> Upload Now
//             </motion.button>
//             <motion.a
//               href={uploadFormLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
//             >
//               <FaExternalLinkAlt /> Request Upload
//             </motion.a>
//           </>
//         ) : (
//           <motion.a
//             href={uploadFormLink}
//             target="_blank"
//             rel="noopener noreferrer"
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             className="flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
//           >
//             <FaExternalLinkAlt /> Request Upload via Form
//           </motion.a>
//         )}
//       </div>

//       <UploadForm
//         category={category}
//         driveTitle={driveTitle}
//         driveLink={driveLink}
//         onDriveTitleChange={(e) => setDriveTitle(e.target.value)}
//         onDriveLinkChange={(e) => setDriveLink(e.target.value)}
//         onUpload={handleDriveLinkUpload}
//         uploadFormLink={uploadFormLink}
//         showForm={showUploadForm}
//         onCloseForm={() => setShowUploadForm(false)}
//       />
//     </motion.div>
//   );

//   const filteredNotes = pdfModal.category ? 
//     notes.filter((note) => note.category === pdfModal.category) : 
//     [];
//   const currentPdf = filteredNotes[pdfModal.currentIndex];

//   return (
//     <section className="max-w-7xl mx-auto px-4 py-8">
//       <motion.h1 
//         className="text-4xl font-bold text-center text-white mb-8 md:mt-20"
//         initial={{ opacity: 0, y: -20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         {subjectName}
//       </motion.h1>

//       {!user ? (
//         <motion.button 
//           onClick={handleGoogleLogin}
//           className="flex items-center gap-2 mx-auto px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
//           whileHover={{ scale: 1.05 }}
//           whileTap={{ scale: 0.95 }}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ delay: 0.3 }}
//         >
//           <FaSignInAlt /> Login with Google
//         </motion.button>
//       ) : (
//         <>
//           <Tabs tabData={tabData.map(tab => {
//             if (tab.id === 'syllabus') {
//               return {
//                 ...tab,
//                 content: <Accordions accordionContent={accordionContent} />
//               };
//             } else if (['notes', 'important', 'books', 'PYQ'].includes(tab.id)) {
//               return {
//                 ...tab,
//                 content: (
//                   <>
//                     {renderUploadButton(tab.id)}
//                     <PdfCards 
//                       notes={notes} 
//                       category={tab.id} 
//                       onOpenModal={openPdfModal} 
//                       onDeleteNote={handleDeleteNote}
//                       isAdmin={user?.email === adminEmail}
//                       renderEmptyState={renderEmptyState}
//                     />
//                   </>
//                 )
//               };
//             } else if (tab.id === 'youtube_playlist') {
//               return {
//                 ...tab,
//                 content: (
//                   <VideoSection
//                     videos={videos}
//                     videoTitle={videoTitle}
//                     videoUrl={videoUrl}
//                     onVideoTitleChange={(e) => setVideoTitle(e.target.value)}
//                     onVideoUrlChange={(e) => setVideoUrl(e.target.value)}
//                     onAddVideo={handleAddVideo}
//                     onDeleteVideo={handleDeleteVideo}
//                     isAdmin={user?.email === adminEmail}
//                     uploadFormLink={uploadFormLink}
//                     subjectKey={subjectKey}
//                   />
//                 )
//               };
//             }
//             return tab;
//           })} />
//         </>
//       )}

//       <PdfViewerModal
//         isOpen={pdfModal.isOpen}
//         onClose={closePdfModal}
//         currentPdf={currentPdf}
//         filteredNotes={filteredNotes}
//         currentIndex={pdfModal.currentIndex}
//         onNavigate={navigatePdf}
//         extractFileId={extractFileId}
//       />
//     </section>
//   );
// };

// export default SubjectPage;








// import React, { useState, useEffect, useMemo } from 'react';
// import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
// import { addDoc, collection, deleteDoc, doc, getDocs } from 'firebase/firestore';
// import { auth, db } from '../../../components/firebase';
// import Tabs from '../../../components/Tabs';
// import { 
//   FaFilePdf, 
//   FaYoutube, 
//   FaGoogleDrive, 
//   FaTrash, 
//   FaSignInAlt, 
//   FaTimes, 
//   FaChevronLeft, 
//   FaChevronRight,
//   FaWhatsapp,
//   FaCopy,
//   FaDownload,
//   FaUpload,
//   FaExternalLinkAlt
// } from 'react-icons/fa';
// import { motion, AnimatePresence } from 'framer-motion';
// import Accordions from '../../../components/Dropdowns';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import PdfViewerModal from './PdfViewerModal';
// import PdfCards from './PdfCards';
// import VideoSection from './VideoSection';
// import UploadForm from './UploadForm';

// // Cache class implementation
// class FirestoreCache {
//   constructor() {
//     this.cache = {};
//     this.timestamps = {};
//     this.CACHE_DURATION = 30 * 60 * 1000; // 30 minutes cache duration
//   }

//   get(key) {
//     const cachedData = this.cache[key];
//     const timestamp = this.timestamps[key];

//     if (cachedData && timestamp && Date.now() - timestamp < this.CACHE_DURATION) {
//       return cachedData;
//     }
//     return null;
//   }

//   set(key, data) {
//     this.cache[key] = data;
//     this.timestamps[key] = Date.now();
//   }

//   clear(key) {
//     delete this.cache[key];
//     delete this.timestamps[key];
//   }

//   clearAll() {
//     this.cache = {};
//     this.timestamps = {};
//   }
// }

// const cache = new FirestoreCache();

// const SubjectPage = ({ 
//   subjectName,
//   subjectKey,
//   accordionContent,
//   tabData,
//   adminEmail,
//   firestoreCollections = {} 
// }) => {
//   // Create collection names based on subjectKey
//   const notesCollection = firestoreCollections.notes || `${subjectKey}-notes`;
//   const videosCollection = firestoreCollections.videos || `${subjectKey}-videos`;

//   const [user, setUser] = useState(null);
//   const [notes, setNotes] = useState([]);
//   const [videos, setVideos] = useState([]);
//   const [videoTitle, setVideoTitle] = useState('');
//   const [videoUrl, setVideoUrl] = useState('');
//   const [driveLink, setDriveLink] = useState('');
//   const [driveTitle, setDriveTitle] = useState('');
//   const [pdfModal, setPdfModal] = useState({
//     isOpen: false,
//     currentIndex: 0,
//     category: null
//   });
//   const [showUploadForm, setShowUploadForm] = useState(false);

//   const uploadFormLink = "https://forms.gle/7xrdusY7ePDNYpJ6A";

//   // Helper function to extract file ID from Google Drive URLs
//   const extractFileId = (url) => {
//     const patterns = [
//       /\/file\/d\/([^\/]+)/,
//       /\/d\/([^\/]+)/,
//       /id=([^&]+)/,
//       /\/folders\/([^\/]+)/,
//       /[-\w]{25,}/
//     ];

//     for (const pattern of patterns) {
//       const match = url.match(pattern);
//       if (match && match[1]) {
//         return match[1];
//       }
//     }
//     return url;
//   };

//   // Memoized filtered notes by category
//   const filteredNotesByCategory = useMemo(() => {
//     const categories = ['notes', 'important', 'books', 'pyq'];
//     return categories.reduce((acc, category) => {
//       acc[category] = notes.filter(note => note.category === category);
//       return acc;
//     }, {});
//   }, [notes]);

//   useEffect(() => {
//     // Check if there's a PDF or Video ID in the URL when the component loads
//     const urlParams = new URLSearchParams(window.location.search);
//     const pdfId = urlParams.get('pdf');
//     const videoId = urlParams.get('video');

//     if (pdfId) {
//       // Find the note with this ID
//       const note = notes.find(n => n.id === pdfId);
//       if (note) {
//         // Find its category and index
//         const category = note.category;
//         const filteredNotes = filteredNotesByCategory[category] || [];
//         const index = filteredNotes.findIndex(n => n.id === pdfId);

//         if (index !== -1) {
//           // Open the modal for this PDF
//           setPdfModal({
//             isOpen: true,
//             currentIndex: index,
//             category: category
//           });

//           // Clean up the URL
//           window.history.replaceState({}, document.title, window.location.pathname);
//         }
//       }
//     } else if (videoId) {
//       // Scroll to videos section and highlight the video
//       const videosTab = document.getElementById('youtube_playlist');
//       if (videosTab) {
//         videosTab.click();
//         setTimeout(() => {
//           const videoElement = document.getElementById(`video-${videoId}`);
//           if (videoElement) {
//             videoElement.scrollIntoView({ behavior: 'smooth' });
//             videoElement.classList.add('ring-2', 'ring-green-500');
//             setTimeout(() => {
//               videoElement.classList.remove('ring-2', 'ring-green-500');
//             }, 3000);
//           }
//         }, 500);
//       }
//     }
//   }, [notes, videos, filteredNotesByCategory]);

//   // Fetch notes from Firestore with caching
//   const fetchNotesFromFirestore = async () => {
//     const cacheKey = notesCollection;
//     const cachedData = cache.get(cacheKey);

//     if (cachedData) {
//       setNotes(cachedData);
//       return;
//     }

//     try {
//       const notesSnapshot = await getDocs(collection(db, notesCollection));
//       const notesData = notesSnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
//       cache.set(cacheKey, notesData);
//       setNotes(notesData);
//     } catch (error) {
//       console.error('Error fetching notes:', error);
//       toast.error('Failed to load notes. Please try again later.');
//     }
//   };

//   // Fetch videos from Firestore with caching
//   const fetchVideos = async () => {
//     const cacheKey = videosCollection;
//     const cachedData = cache.get(cacheKey);

//     if (cachedData) {
//       setVideos(cachedData);
//       return;
//     }

//     try {
//       const videoCollection = collection(db, videosCollection);
//       const videoSnapshot = await getDocs(videoCollection);
//       const videosData = videoSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       cache.set(cacheKey, videosData);
//       setVideos(videosData);
//     } catch (error) {
//       console.error('Error fetching videos:', error);
//       toast.error('Failed to load videos. Please try again later.');
//     }
//   };

//   // Monitor user authentication state
//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       setUser(user);
//     });
//     return () => unsubscribe();
//   }, []);

//   // Initial data fetch
//   useEffect(() => {
//     fetchNotesFromFirestore();
//     fetchVideos();
//   }, [notesCollection, videosCollection]);

//   // Open PDF modal and set current index
//   const openPdfModal = (category, index) => {
//     setPdfModal({
//       isOpen: true,
//       currentIndex: index,
//       category: category
//     });
//   };

//   // Navigate between PDFs in the modal
//   const navigatePdf = (direction) => {
//     const filteredNotes = filteredNotesByCategory[pdfModal.category] || [];
//     let newIndex;

//     if (direction === 'prev') {
//       newIndex = pdfModal.currentIndex === 0 ? filteredNotes.length - 1 : pdfModal.currentIndex - 1;
//     } else {
//       newIndex = pdfModal.currentIndex === filteredNotes.length - 1 ? 0 : pdfModal.currentIndex + 1;
//     }

//     setPdfModal(prev => ({
//       ...prev,
//       currentIndex: newIndex
//     }));
//   };

//   // Close PDF modal
//   const closePdfModal = () => {
//     setPdfModal({
//       isOpen: false,
//       currentIndex: 0,
//       category: null
//     });
//   };

//   // Google Sign-In
//   const handleGoogleLogin = async () => {
//     const provider = new GoogleAuthProvider();
//     try {
//       const result = await signInWithPopup(auth, provider);
//       setUser(result.user);
//     } catch (error) {
//       console.error('Error during Google login:', error);
//       toast.error('Failed to sign in. Please try again.');
//     }
//   };

//   // File upload handler
//   const handleDriveLinkUpload = async (category) => {
//     if (!driveLink || !driveTitle) {
//       toast.warning('Please provide both a valid title and Google Drive link.');
//       return;
//     }

//     // Validate Google Drive link
//     const fileId = extractFileId(driveLink);
//     if (!fileId) {
//       toast.warning('Please provide a valid Google Drive link');
//       return;
//     }

//     const newNote = { 
//       title: driveTitle, 
//       category, 
//       link: `https://drive.google.com/file/d/${fileId}/view?usp=sharing`,
//       directPreviewLink: `https://drive.google.com/file/d/${fileId}/preview`
//     };

//     try {
//       const docRef = await addDoc(collection(db, notesCollection), newNote);
//       const updatedNote = { ...newNote, id: docRef.id };

//       // Update local state
//       setNotes(prevNotes => [...prevNotes, updatedNote]);

//       // Clear cache for notes
//       cache.clear(notesCollection);

//       toast.success('Google Drive link uploaded successfully!');
//       setDriveLink('');
//       setDriveTitle('');
//     } catch (error) {
//       console.error('Error uploading document: ', error);
//       toast.error('Error uploading document. Please try again.');
//     }
//   };

//   // Handle deleting a note
//   const handleDeleteNote = async (note) => {
//     if (window.confirm('Are you sure you want to delete this note?')) {
//       try {
//         await deleteDoc(doc(db, notesCollection, note.id));

//         // Update local state
//         setNotes(prevNotes => prevNotes.filter((n) => n.id !== note.id));

//         // Clear cache for notes
//         cache.clear(notesCollection);

//         // Close modal if currently viewing the deleted note
//         if (pdfModal.isOpen && pdfModal.currentNoteId === note.id) {
//           closePdfModal();
//         }

//         toast.success('Note deleted successfully');
//       } catch (error) {
//         console.error('Error deleting document: ', error);
//         toast.error('Error deleting document. Please try again.');
//       }
//     }
//   };

//   // Handle adding a video
//   const handleAddVideo = async () => {
//     if (!videoTitle || !videoUrl) {
//       toast.warning('Please provide both a valid title and video URL.');
//       return;
//     }

//     let formattedUrl = '';
//     if (videoUrl.includes('youtube.com/live')) {
//       const videoId = videoUrl.split('/').pop();
//       formattedUrl = `https://www.youtube.com/embed/${videoId}`;
//     } else if (videoUrl.includes('youtube.com/watch?v=')) {
//       const videoId = new URL(videoUrl).searchParams.get('v');
//       formattedUrl = `https://www.youtube.com/embed/${videoId}`;
//     } else if (videoUrl.includes('youtube.com/playlist?list=')) {
//       const playlistId = new URL(videoUrl).searchParams.get('list');
//       formattedUrl = `https://www.youtube.com/embed/videoseries?list=${playlistId}`;
//     } else {
//       toast.warning('Please provide a valid YouTube video, live stream, or playlist URL.');
//       return;
//     }

//     try {
//       const newVideo = { title: videoTitle, link: formattedUrl };
//       const videoRef = await addDoc(collection(db, videosCollection), newVideo);
//       const updatedVideo = { id: videoRef.id, ...newVideo };

//       // Update local state
//       setVideos(prevVideos => [...prevVideos, updatedVideo]);

//       // Clear cache for videos
//       cache.clear(videosCollection);

//       setVideoTitle('');
//       setVideoUrl('');
//       toast.success('Video added successfully!');
//     } catch (error) {
//       console.error('Error adding video: ', error);
//       toast.error('Error adding video. Please try again.');
//     }
//   };

//   // Handle deleting a video
//   const handleDeleteVideo = async (videoId) => {
//     if (window.confirm('Are you sure you want to delete this video?')) {
//       try {
//         await deleteDoc(doc(db, videosCollection, videoId));

//         // Update local state
//         setVideos(prevVideos => prevVideos.filter((video) => video.id !== videoId));

//         // Clear cache for videos
//         cache.clear(videosCollection);

//         toast.success('Video deleted successfully');
//       } catch (error) {
//         console.error('Error deleting video: ', error);
//         toast.error('Error deleting video. Please try again.');
//       }
//     }
//   };

//   // Render upload button with Google Drive link input
//   const renderUploadButton = (category) => (
//     <motion.div 
//       className="mb-8"
//       initial={{ opacity: 0, y: -20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.3 }}
//     >
//       {user?.email === adminEmail && (
//         <div className="flex flex-wrap gap-4 items-center mb-6">
//           <input
//             type="text"
//             placeholder="Note Title"
//             value={driveTitle}
//             onChange={(e) => setDriveTitle(e.target.value)}
//             className="flex-1 min-w-[200px] p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
//           />
//           <input
//             type="text"
//             placeholder="Google Drive Link"
//             value={driveLink}
//             onChange={(e) => setDriveLink(e.target.value)}
//             className="flex-1 min-w-[200px] p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
//           />
//           <motion.button 
//             onClick={() => handleDriveLinkUpload(category)}
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
//           >
//             <FaGoogleDrive /> Upload Link
//           </motion.button>
//         </div>
//       )}
//     </motion.div>
//   );

//   // Render empty state with upload option
//   const renderEmptyState = (category) => (
//     <motion.div 
//       className="flex flex-col items-center justify-center gap-4 p-8 text-gray-500"
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 0.5 }}
//     >
//       <FaFilePdf size={48} className="text-gray-300" />
//       <p className="text-lg">No {category} uploaded yet</p>

//       <div className="flex flex-col sm:flex-row gap-4 mt-4">
//         {user?.email === adminEmail ? (
//           <>
//             <motion.button
//               onClick={() => setShowUploadForm(true)}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
//             >
//               <FaUpload /> Upload Now
//             </motion.button>
//             <motion.a
//               href={uploadFormLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
//             >
//               <FaExternalLinkAlt /> Request Upload
//             </motion.a>
//           </>
//         ) : (
//           <motion.a
//             href={uploadFormLink}
//             target="_blank"
//             rel="noopener noreferrer"
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             className="flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
//           >
//             <FaExternalLinkAlt /> Request Upload via Form
//           </motion.a>
//         )}
//       </div>

//       <UploadForm
//         category={category}
//         driveTitle={driveTitle}
//         driveLink={driveLink}
//         onDriveTitleChange={(e) => setDriveTitle(e.target.value)}
//         onDriveLinkChange={(e) => setDriveLink(e.target.value)}
//         onUpload={handleDriveLinkUpload}
//         uploadFormLink={uploadFormLink}
//         showForm={showUploadForm}
//         onCloseForm={() => setShowUploadForm(false)}
//       />
//     </motion.div>
//   );

//   const filteredNotes = pdfModal.category ? 
//     filteredNotesByCategory[pdfModal.category] || [] : 
//     [];
//   const currentPdf = filteredNotes[pdfModal.currentIndex];

//   return (
//     <section className="max-w-7xl mx-auto px-4 py-8">
//       <motion.h1 
//         className="text-4xl font-bold text-center text-white mb-8 md:mt-20"
//         initial={{ opacity: 0, y: -20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         {subjectName}
//       </motion.h1>

//       {!user ? (
//         <motion.button 
//           onClick={handleGoogleLogin}
//           className="flex items-center gap-2 mx-auto px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
//           whileHover={{ scale: 1.05 }}
//           whileTap={{ scale: 0.95 }}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ delay: 0.3 }}
//         >
//           <FaSignInAlt /> Login with Google
//         </motion.button>
//       ) : (
//         <>
//           <Tabs tabData={tabData.map(tab => {
//             if (tab.id === 'syllabus') {
//               return {
//                 ...tab,
//                 content: <Accordions accordionContent={accordionContent} />
//               };
//             } else if (['notes', 'important', 'books', 'PYQ'].includes(tab.id)) {
//               return {
//                 ...tab,
//                 content: (
//                   <>
//                     {renderUploadButton(tab.id)}
//                     <PdfCards 
//                       notes={notes} 
//                       category={tab.id} 
//                       onOpenModal={openPdfModal} 
//                       onDeleteNote={handleDeleteNote}
//                       isAdmin={user?.email === adminEmail}
//                       renderEmptyState={renderEmptyState}
//                     />
//                   </>
//                 )
//               };
//             } else if (tab.id === 'youtube_playlist') {
//               return {
//                 ...tab,
//                 content: (
//                   <VideoSection
//                     videos={videos}
//                     videoTitle={videoTitle}
//                     videoUrl={videoUrl}
//                     onVideoTitleChange={(e) => setVideoTitle(e.target.value)}
//                     onVideoUrlChange={(e) => setVideoUrl(e.target.value)}
//                     onAddVideo={handleAddVideo}
//                     onDeleteVideo={handleDeleteVideo}
//                     isAdmin={user?.email === adminEmail}
//                     uploadFormLink={uploadFormLink}
//                     subjectKey={subjectKey}
//                   />
//                 )
//               };
//             }
//             return tab;
//           })} />
//         </>
//       )}

//       <PdfViewerModal
//         isOpen={pdfModal.isOpen}
//         onClose={closePdfModal}
//         currentPdf={currentPdf}
//         filteredNotes={filteredNotes}
//         currentIndex={pdfModal.currentIndex}
//         onNavigate={navigatePdf}
//         extractFileId={extractFileId}
//       />
//     </section>
//   );
// };

// export default SubjectPage;








// import React, { useState, useEffect, useMemo } from 'react';
// import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
// import { addDoc, collection, deleteDoc, doc, getDocs } from 'firebase/firestore';
// import { auth, db } from '../../../components/firebase';
// import Tabs from '../../../components/Tabs';
// import { 
//   FaFilePdf, 
//   FaYoutube, 
//   FaGoogleDrive, 
//   FaTrash, 
//   FaSignInAlt, 
//   FaTimes, 
//   FaChevronLeft, 
//   FaChevronRight,
//   FaWhatsapp,
//   FaCopy,
//   FaDownload,
//   FaUpload,
//   FaExternalLinkAlt
// } from 'react-icons/fa';
// import { motion, AnimatePresence } from 'framer-motion';
// import Accordions from '../../../components/Dropdowns';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import PdfViewerModal from './PdfViewerModal';
// import PdfCards from './PdfCards';
// import VideoSection from './VideoSection';
// import UploadForm from './UploadForm';

// // Cache class implementation
// class FirestoreCache {
//   constructor() {
//     this.cache = {};
//     this.timestamps = {};
//     this.CACHE_DURATION = 30 * 60 * 1000; // 30 minutes cache duration
//   }

//   get(key) {
//     const cachedData = this.cache[key];
//     const timestamp = this.timestamps[key];

//     if (cachedData && timestamp && Date.now() - timestamp < this.CACHE_DURATION) {
//       return cachedData;
//     }
//     return null;
//   }

//   set(key, data) {
//     this.cache[key] = data;
//     this.timestamps[key] = Date.now();
//   }

//   clear(key) {
//     delete this.cache[key];
//     delete this.timestamps[key];
//   }

//   clearAll() {
//     this.cache = {};
//     this.timestamps = {};
//   }
// }

// const cache = new FirestoreCache();

// const SubjectPage = ({ 
//   subjectName,
//   subjectKey,
//   accordionContent,
//   tabData,
//   adminEmail,
//   firestoreCollections = {} 
// }) => {
//   // Create collection names based on subjectKey
//   const notesCollection = firestoreCollections.notes || `${subjectKey}-notes`;
//   const videosCollection = firestoreCollections.videos || `${subjectKey}-videos`;

//   const [user, setUser] = useState(null);
//   const [notes, setNotes] = useState([]);
//   const [videos, setVideos] = useState([]);
//   const [videoTitle, setVideoTitle] = useState('');
//   const [videoUrl, setVideoUrl] = useState('');
//   const [driveLink, setDriveLink] = useState('');
//   const [driveTitle, setDriveTitle] = useState('');
//   const [pdfModal, setPdfModal] = useState({
//     isOpen: false,
//     currentIndex: 0,
//     category: null
//   });
//   const [showUploadForm, setShowUploadForm] = useState(false);

//   const uploadFormLink = "https://forms.gle/7xrdusY7ePDNYpJ6A";

//   // Helper function to extract file ID from Google Drive URLs
//   const extractFileId = (url) => {
//     const patterns = [
//       /\/file\/d\/([^\/]+)/,
//       /\/d\/([^\/]+)/,
//       /id=([^&]+)/,
//       /\/folders\/([^\/]+)/,
//       /[-\w]{25,}/
//     ];

//     for (const pattern of patterns) {
//       const match = url.match(pattern);
//       if (match && match[1]) {
//         return match[1];
//       }
//     }
//     return url;
//   };

//   // Memoized filtered notes by category
//   const filteredNotesByCategory = useMemo(() => {
//     const categories = ['notes', 'important', 'books', 'pyq'];
//     return categories.reduce((acc, category) => {
//       acc[category] = notes.filter(note => note.category.toLowerCase() === category);
//       return acc;
//     }, {});
//   }, [notes]);

//   useEffect(() => {
//     // Check if there's a PDF or Video ID in the URL when the component loads
//     const urlParams = new URLSearchParams(window.location.search);
//     const pdfId = urlParams.get('pdf');
//     const videoId = urlParams.get('video');

//     if (pdfId) {
//       // Find the note with this ID
//       const note = notes.find(n => n.id === pdfId);
//       if (note) {
//         // Find its category and index
//         const category = note.category.toLowerCase();
//         const filteredNotes = filteredNotesByCategory[category] || [];
//         const index = filteredNotes.findIndex(n => n.id === pdfId);

//         if (index !== -1) {
//           // Open the modal for this PDF
//           setPdfModal({
//             isOpen: true,
//             currentIndex: index,
//             category: category
//           });

//           // Clean up the URL
//           window.history.replaceState({}, document.title, window.location.pathname);
//         }
//       }
//     } else if (videoId) {
//       // Scroll to videos section and highlight the video
//       const videosTab = document.getElementById('youtube_playlist');
//       if (videosTab) {
//         videosTab.click();
//         setTimeout(() => {
//           const videoElement = document.getElementById(`video-${videoId}`);
//           if (videoElement) {
//             videoElement.scrollIntoView({ behavior: 'smooth' });
//             videoElement.classList.add('ring-2', 'ring-green-500');
//             setTimeout(() => {
//               videoElement.classList.remove('ring-2', 'ring-green-500');
//             }, 3000);
//           }
//         }, 500);
//       }
//     }
//   }, [notes, videos, filteredNotesByCategory]);

//   // Fetch notes from Firestore with caching
//   const fetchNotesFromFirestore = async () => {
//     const cacheKey = notesCollection;
//     const cachedData = cache.get(cacheKey);

//     if (cachedData) {
//       setNotes(cachedData);
//       return;
//     }

//     try {
//       const notesSnapshot = await getDocs(collection(db, notesCollection));
//       const notesData = notesSnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
//       cache.set(cacheKey, notesData);
//       setNotes(notesData);
//     } catch (error) {
//       console.error('Error fetching notes:', error);
//       toast.error('Failed to load notes. Please try again later.');
//     }
//   };

//   // Fetch videos from Firestore with caching
//   const fetchVideos = async () => {
//     const cacheKey = videosCollection;
//     const cachedData = cache.get(cacheKey);

//     if (cachedData) {
//       setVideos(cachedData);
//       return;
//     }

//     try {
//       const videoCollection = collection(db, videosCollection);
//       const videoSnapshot = await getDocs(videoCollection);
//       const videosData = videoSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       cache.set(cacheKey, videosData);
//       setVideos(videosData);
//     } catch (error) {
//       console.error('Error fetching videos:', error);
//       toast.error('Failed to load videos. Please try again later.');
//     }
//   };

//   // Monitor user authentication state
//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       setUser(user);
//     });
//     return () => unsubscribe();
//   }, []);

//   // Initial data fetch
//   useEffect(() => {
//     fetchNotesFromFirestore();
//     fetchVideos();
//   }, [notesCollection, videosCollection]);

//   // Open PDF modal and set current index
//   const openPdfModal = (category, index) => {
//     setPdfModal({
//       isOpen: true,
//       currentIndex: index,
//       category: category.toLowerCase() // Ensure lowercase for consistency
//     });
//   };

//   // Navigate between PDFs in the modal
//   const navigatePdf = (direction) => {
//     const filteredNotes = filteredNotesByCategory[pdfModal.category] || [];
//     let newIndex;

//     if (direction === 'prev') {
//       newIndex = pdfModal.currentIndex === 0 ? filteredNotes.length - 1 : pdfModal.currentIndex - 1;
//     } else {
//       newIndex = pdfModal.currentIndex === filteredNotes.length - 1 ? 0 : pdfModal.currentIndex + 1;
//     }

//     setPdfModal(prev => ({
//       ...prev,
//       currentIndex: newIndex
//     }));
//   };

//   // Close PDF modal
//   const closePdfModal = () => {
//     setPdfModal({
//       isOpen: false,
//       currentIndex: 0,
//       category: null
//     });
//   };

//   // Google Sign-In
//   const handleGoogleLogin = async () => {
//     const provider = new GoogleAuthProvider();
//     try {
//       const result = await signInWithPopup(auth, provider);
//       setUser(result.user);
//     } catch (error) {
//       console.error('Error during Google login:', error);
//       toast.error('Failed to sign in. Please try again.');
//     }
//   };

//   // File upload handler
//   const handleDriveLinkUpload = async (category) => {
//     if (!driveLink || !driveTitle) {
//       toast.warning('Please provide both a valid title and Google Drive link.');
//       return;
//     }

//     // Validate Google Drive link
//     const fileId = extractFileId(driveLink);
//     if (!fileId) {
//       toast.warning('Please provide a valid Google Drive link');
//       return;
//     }

//     const newNote = { 
//       title: driveTitle, 
//       category: category.toLowerCase(), // Ensure lowercase for consistency
//       link: `https://drive.google.com/file/d/${fileId}/view?usp=sharing`,
//       directPreviewLink: `https://drive.google.com/file/d/${fileId}/preview`
//     };

//     try {
//       const docRef = await addDoc(collection(db, notesCollection), newNote);
//       const updatedNote = { ...newNote, id: docRef.id };

//       // Update local state
//       setNotes(prevNotes => [...prevNotes, updatedNote]);

//       // Clear cache for notes
//       cache.clear(notesCollection);

//       toast.success('Google Drive link uploaded successfully!');
//       setDriveLink('');
//       setDriveTitle('');
//     } catch (error) {
//       console.error('Error uploading document: ', error);
//       toast.error('Error uploading document. Please try again.');
//     }
//   };

//   // Handle deleting a note
//   const handleDeleteNote = async (note) => {
//     if (window.confirm('Are you sure you want to delete this note?')) {
//       try {
//         await deleteDoc(doc(db, notesCollection, note.id));

//         // Update local state
//         setNotes(prevNotes => prevNotes.filter((n) => n.id !== note.id));

//         // Clear cache for notes
//         cache.clear(notesCollection);

//         // Close modal if currently viewing the deleted note
//         if (pdfModal.isOpen && pdfModal.currentNoteId === note.id) {
//           closePdfModal();
//         }

//         toast.success('Note deleted successfully');
//       } catch (error) {
//         console.error('Error deleting document: ', error);
//         toast.error('Error deleting document. Please try again.');
//       }
//     }
//   };

//   // Handle adding a video
//   const handleAddVideo = async () => {
//     if (!videoTitle || !videoUrl) {
//       toast.warning('Please provide both a valid title and video URL.');
//       return;
//     }

//     let formattedUrl = '';
//     if (videoUrl.includes('youtube.com/live')) {
//       const videoId = videoUrl.split('/').pop();
//       formattedUrl = `https://www.youtube.com/embed/${videoId}`;
//     } else if (videoUrl.includes('youtube.com/watch?v=')) {
//       const videoId = new URL(videoUrl).searchParams.get('v');
//       formattedUrl = `https://www.youtube.com/embed/${videoId}`;
//     } else if (videoUrl.includes('youtube.com/playlist?list=')) {
//       const playlistId = new URL(videoUrl).searchParams.get('list');
//       formattedUrl = `https://www.youtube.com/embed/videoseries?list=${playlistId}`;
//     } else {
//       toast.warning('Please provide a valid YouTube video, live stream, or playlist URL.');
//       return;
//     }

//     try {
//       const newVideo = { title: videoTitle, link: formattedUrl };
//       const videoRef = await addDoc(collection(db, videosCollection), newVideo);
//       const updatedVideo = { id: videoRef.id, ...newVideo };

//       // Update local state
//       setVideos(prevVideos => [...prevVideos, updatedVideo]);

//       // Clear cache for videos
//       cache.clear(videosCollection);

//       setVideoTitle('');
//       setVideoUrl('');
//       toast.success('Video added successfully!');
//     } catch (error) {
//       console.error('Error adding video: ', error);
//       toast.error('Error adding video. Please try again.');
//     }
//   };

//   // Handle deleting a video
//   const handleDeleteVideo = async (videoId) => {
//     if (window.confirm('Are you sure you want to delete this video?')) {
//       try {
//         await deleteDoc(doc(db, videosCollection, videoId));

//         // Update local state
//         setVideos(prevVideos => prevVideos.filter((video) => video.id !== videoId));

//         // Clear cache for videos
//         cache.clear(videosCollection);

//         toast.success('Video deleted successfully');
//       } catch (error) {
//         console.error('Error deleting video: ', error);
//         toast.error('Error deleting video. Please try again.');
//       }
//     }
//   };

//   // Render upload button with Google Drive link input
//   const renderUploadButton = (category) => (
//     <motion.div 
//       className="mb-8"
//       initial={{ opacity: 0, y: -20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.3 }}
//     >
//       {user?.email === adminEmail && (
//         <div className="flex flex-wrap gap-4 items-center mb-6">
//           <input
//             type="text"
//             placeholder="Note Title"
//             value={driveTitle}
//             onChange={(e) => setDriveTitle(e.target.value)}
//             className="flex-1 min-w-[200px] p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
//           />
//           <input
//             type="text"
//             placeholder="Google Drive Link"
//             value={driveLink}
//             onChange={(e) => setDriveLink(e.target.value)}
//             className="flex-1 min-w-[200px] p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
//           />
//           <motion.button 
//             onClick={() => handleDriveLinkUpload(category)}
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
//           >
//             <FaGoogleDrive /> Upload Link
//           </motion.button>
//         </div>
//       )}
//     </motion.div>
//   );

//   // Render empty state with upload option
//   const renderEmptyState = (category) => (
//     <motion.div 
//       className="flex flex-col items-center justify-center gap-4 p-8 text-gray-500"
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 0.5 }}
//     >
//       <FaFilePdf size={48} className="text-gray-300" />
//       <p className="text-lg">No {category} uploaded yet</p>

//       <div className="flex flex-col sm:flex-row gap-4 mt-4">
//         {user?.email === adminEmail ? (
//           <>
//             <motion.button
//               onClick={() => setShowUploadForm(true)}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
//             >
//               <FaUpload /> Upload Now
//             </motion.button>
//             <motion.a
//               href={uploadFormLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
//             >
//               <FaExternalLinkAlt /> Request Upload
//             </motion.a>
//           </>
//         ) : (
//           <motion.a
//             href={uploadFormLink}
//             target="_blank"
//             rel="noopener noreferrer"
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             className="flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
//           >
//             <FaExternalLinkAlt /> Request Upload via Form
//           </motion.a>
//         )}
//       </div>

//       <UploadForm
//         category={category}
//         driveTitle={driveTitle}
//         driveLink={driveLink}
//         onDriveTitleChange={(e) => setDriveTitle(e.target.value)}
//         onDriveLinkChange={(e) => setDriveLink(e.target.value)}
//         onUpload={handleDriveLinkUpload}
//         uploadFormLink={uploadFormLink}
//         showForm={showUploadForm}
//         onCloseForm={() => setShowUploadForm(false)}
//       />
//     </motion.div>
//   );

//   const filteredNotes = pdfModal.category ? 
//     filteredNotesByCategory[pdfModal.category] || [] : 
//     [];
//   const currentPdf = filteredNotes[pdfModal.currentIndex];

//   return (
//     <section className="max-w-7xl mx-auto px-4 py-8">
//       <motion.h1 
//         className="text-4xl font-bold text-center text-white mb-8 md:mt-20"
//         initial={{ opacity: 0, y: -20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         {subjectName}
//       </motion.h1>

//       {!user ? (
//         <motion.button 
//           onClick={handleGoogleLogin}
//           className="flex items-center gap-2 mx-auto px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
//           whileHover={{ scale: 1.05 }}
//           whileTap={{ scale: 0.95 }}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ delay: 0.3 }}
//         >
//           <FaSignInAlt /> Login with Google
//         </motion.button>
//       ) : (
//         <>
//           <Tabs tabData={tabData.map(tab => {
//             if (tab.id === 'syllabus') {
//               return {
//                 ...tab,
//                 content: <Accordions accordionContent={accordionContent} />
//               };
//             } else if (['notes', 'important', 'books', 'PYQ'].includes(tab.id)) {
//               const category = tab.id.toLowerCase(); // Convert to lowercase for consistency
//               return {
//                 ...tab,
//                 content: (
//                   <>
//                     {renderUploadButton(category)}
//                     <PdfCards 
//                       notes={notes} 
//                       category={category} 
//                       onOpenModal={openPdfModal} 
//                       onDeleteNote={handleDeleteNote}
//                       isAdmin={user?.email === adminEmail}
//                       renderEmptyState={renderEmptyState}
//                     />
//                   </>
//                 )
//               };
//             } else if (tab.id === 'youtube_playlist') {
//               return {
//                 ...tab,
//                 content: (
//                   <VideoSection
//                     videos={videos}
//                     videoTitle={videoTitle}
//                     videoUrl={videoUrl}
//                     onVideoTitleChange={(e) => setVideoTitle(e.target.value)}
//                     onVideoUrlChange={(e) => setVideoUrl(e.target.value)}
//                     onAddVideo={handleAddVideo}
//                     onDeleteVideo={handleDeleteVideo}
//                     isAdmin={user?.email === adminEmail}
//                     uploadFormLink={uploadFormLink}
//                     subjectKey={subjectKey}
//                   />
//                 )
//               };
//             }
//             return tab;
//           })} />
//         </>
//       )}

//       <PdfViewerModal
//         isOpen={pdfModal.isOpen}
//         onClose={closePdfModal}
//         currentPdf={currentPdf}
//         filteredNotes={filteredNotes}
//         currentIndex={pdfModal.currentIndex}
//         onNavigate={navigatePdf}
//         extractFileId={extractFileId}
//       />
//     </section>
//   );
// };

// export default SubjectPage;






import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { addDoc, collection, deleteDoc, doc, getDocs, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import SEO from '../../../components/SEO';
import { auth, db } from '../../../components/firebase';
import Tabs from '../../../components/Tabs';
import BackButton from '../../../components/BackButton';
import {
  FaFilePdf,
  FaYoutube,
  FaGoogleDrive,
  FaTrash,
  FaSignInAlt,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaWhatsapp,
  FaCopy,
  FaDownload,
  FaUpload,
  FaExternalLinkAlt
} from 'react-icons/fa';
import { FiHome, FiChevronRight, FiBookOpen, FiChevronDown, FiBook, FiMaximize } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import Accordions from '../../../components/Dropdowns';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PdfViewerModal from './PdfViewerModal';
import PdfCards from './PdfCards';
import VideoSection from './VideoSection';
import UploadForm from './UploadForm';
import { useTheme } from '../../../context/ThemeContext';

// Cache class implementation
class FirestoreCache {
  constructor() {
    this.cache = {};
    this.timestamps = {};
    this.CACHE_DURATION = 30 * 60 * 1000; // 30 minutes cache duration
  }

  get(key) {
    const cachedData = this.cache[key];
    const timestamp = this.timestamps[key];

    if (cachedData && timestamp && Date.now() - timestamp < this.CACHE_DURATION) {
      return cachedData;
    }
    return null;
  }

  set(key, data) {
    this.cache[key] = data;
    this.timestamps[key] = Date.now();
  }

  clear(key) {
    delete this.cache[key];
    delete this.timestamps[key];
  }

  clearAll() {
    this.cache = {};
    this.timestamps = {};
  }
}

const cache = new FirestoreCache();

const SubjectPage = ({
  subjectName,
  subjectKey,
  accordionContent,
  tabData,
  adminEmail,
  branch: propBranch,
  semester: propSemester,
  firestoreCollections = {}
}) => {
  const navigate = useNavigate();
  const { branch: urlBranch, sem: urlSem } = useParams();
  const { isDarkMode } = useTheme();

  const c = {
    bg: 'var(--bg-main)',
    card: 'var(--bg-card)',
    surface: 'var(--bg-surface)',
    border: 'var(--border)',
    text: 'var(--text-main)',
    muted: 'var(--text-muted)',
    accent: 'var(--accent)',
    glass: 'var(--glass)',
    glassBorder: 'var(--glass-border)'
  };

  // Normalize branch and semester from URL or props
  const branch = (urlBranch || propBranch || "CSE").toUpperCase();
  const semester = urlSem
    ? (urlSem.match(/^\d/) ? `${urlSem} Semester` : urlSem)
    : (propSemester || "1st Semester");

  const notesCollection = firestoreCollections.notes || `${subjectKey}-notes`;
  const videosCollection = firestoreCollections.videos || `${subjectKey}-videos`;

  const [user, setUser] = useState(null);
  const [notes, setNotes] = useState([]);
  const [videos, setVideos] = useState([]);
  const [videoTitle, setVideoTitle] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [videoUnit, setVideoUnit] = useState('Unit 1');
  const [isPlaylist, setIsPlaylist] = useState(false);
  const [driveLink, setDriveLink] = useState('');
  const [driveTitle, setDriveTitle] = useState('');
  const [pdfModal, setPdfModal] = useState({
    isOpen: false,
    currentIndex: 0,
    category: null
  });
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('Theory');
  const [expandedUnit, setExpandedUnit] = useState(null);

  // Deep link detection
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const tabParam = searchParams.get('tab');
    const videoParam = searchParams.get('video');
    const unitParam = searchParams.get('unit');

    if (tabParam) {
      const validTabs = ['Theory', 'Notes', 'PYQs', 'Books', 'Videos', 'Practicals'];
      const matchedTab = validTabs.find(t => t.toLowerCase() === tabParam.toLowerCase());
      if (matchedTab) setActiveTab(matchedTab);
    }

    if (videoParam || unitParam) {
      setActiveTab('Videos');
    }
  }, []);

  // New states for subject details and syllabus
  const [subjectDetails, setSubjectDetails] = useState({
    theoryCode: 'N/A',
    theoryCredits: 'N/A',
    practicalCode: 'N/A',
    practicalCredits: 'N/A'
  });
  const [dynamicSyllabus, setDynamicSyllabus] = useState([]);
  const [isEditingDetails, setIsEditingDetails] = useState(false);
  const [editingDetails, setEditingDetails] = useState({});
  const [editingUnitIndex, setEditingUnitIndex] = useState(null);
  const [editingUnitData, setEditingUnitData] = useState({ title: '', content: '' });

  const uploadFormLink = "https://forms.gle/7xrdusY7ePDNYpJ6A";

  const extractFileId = (url) => {
    const patterns = [/\/file\/d\/([^\/]+)/, /\/d\/([^\/]+)/, /id=([^&]+)/, /\/folders\/([^\/]+)/, /[-\w]{25,}/];
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) return match[1];
    }
    return url;
  };

  const filteredNotesByCategory = useMemo(() => {
    const categories = ['notes', 'important', 'books', 'pyq', 'practicals'];
    return categories.reduce((acc, category) => {
      acc[category] = notes.filter(note => note.category.toLowerCase() === category);
      return acc;
    }, {});
  }, [notes]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const pdfId = urlParams.get('pdf');
    if (pdfId) {
      const note = notes.find(n => n.id === pdfId);
      if (note) {
        const category = note.category.toLowerCase();
        const filteredNotes = filteredNotesByCategory[category] || [];
        const index = filteredNotes.findIndex(n => n.id === pdfId);
        if (index !== -1) {
          setPdfModal({ isOpen: true, currentIndex: index, category });
          window.history.replaceState({}, document.title, window.location.pathname);
        }
      }
    }
  }, [notes, filteredNotesByCategory]);

  const fetchNotesFromFirestore = async () => {
    const cachedData = cache.get(notesCollection);
    if (cachedData) { setNotes(cachedData); setIsLoading(false); return; }
    try {
      const notesSnapshot = await getDocs(collection(db, notesCollection));
      const notesData = notesSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      cache.set(notesCollection, notesData);
      setNotes(notesData);
      setIsLoading(false);
    } catch (error) { toast.error('Failed to load notes.'); setIsLoading(false); }
  };

  const fetchVideos = async () => {
    const cachedData = cache.get(videosCollection);
    if (cachedData) { setVideos(cachedData); return; }
    try {
      const videoSnapshot = await getDocs(collection(db, videosCollection));
      const videosData = videoSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      cache.set(videosCollection, videosData);
      setVideos(videosData);
    } catch (error) { console.error(error); }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => setUser(user));
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    fetchNotesFromFirestore();
    fetchVideos();
    fetchSubjectData();
  }, [notesCollection, videosCollection, subjectKey]);

  const fetchSubjectData = async () => {
    try {
      const subjectRef = doc(db, 'subjects', subjectKey);
      const docSnap = await getDoc(subjectRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setSubjectDetails({
          theoryCode: data.theoryCode || 'N/A',
          theoryCredits: data.theoryCredits || 'N/A',
          practicalCode: data.practicalCode || 'N/A',
          practicalCredits: data.practicalCredits || 'N/A'
        });
        if (data.syllabus) {
          setDynamicSyllabus(data.syllabus);
        } else {
          normalizeSyllabus(accordionContent);
        }
      } else {
        // Fallback to accordionContent props and default details
        normalizeSyllabus(accordionContent);
        setSubjectDetails({
          theoryCode: 'BS-105', // Example default
          theoryCredits: '3',
          practicalCode: 'BS-151',
          practicalCredits: '1'
        });
      }
    } catch (error) {
      console.error("Error fetching subject data:", error);
      normalizeSyllabus(accordionContent);
    }
  };

  const normalizeSyllabus = (content) => {
    if (!content || !Array.isArray(content)) {
      setDynamicSyllabus([]);
      return;
    }

    const normalized = content.map((unit, index) => {
      // If unit is already an object {title, content}
      if (typeof unit === 'object' && unit !== null && 'title' in unit && 'content' in unit) {
        return unit;
      }

      // If unit is a React element (common in this codebase)
      // Extract text content from the element if possible, otherwise we'll have to handle it in render
      let textContent = '';
      if (React.isValidElement(unit)) {
        // This is tricky as we can't easily extract text from rendered elements
        // For now, we'll store it but it won't be easily editable as text
        textContent = "JSX Content (Edit to replace)";
      } else if (typeof unit === 'string') {
        textContent = unit;
      }

      return {
        title: `Unit ${index + 1}`,
        content: textContent
      };
    });
    setDynamicSyllabus(normalized);
  };

  const handleSaveDetails = async () => {
    try {
      setIsLoading(true);
      const subjectRef = doc(db, 'subjects', subjectKey);
      await setDoc(subjectRef, {
        ...editingDetails,
        updatedAt: new Date()
      }, { merge: true });

      setSubjectDetails(editingDetails);
      setIsEditingDetails(false);
      toast.success('Subject details updated!');
    } catch (error) {
      console.error("Error saving details:", error);
      toast.error('Failed to save details.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveUnit = async () => {
    try {
      setIsLoading(true);
      const updatedSyllabus = [...dynamicSyllabus];
      if (editingUnitIndex === -1) {
        updatedSyllabus.push(editingUnitData);
      } else {
        updatedSyllabus[editingUnitIndex] = editingUnitData;
      }

      const subjectRef = doc(db, 'subjects', subjectKey);
      await setDoc(subjectRef, {
        syllabus: updatedSyllabus,
        updatedAt: new Date()
      }, { merge: true });

      setDynamicSyllabus(updatedSyllabus);
      setEditingUnitIndex(null);
      toast.success('Syllabus updated!');
    } catch (error) {
      console.error("Error saving syllabus:", error);
      toast.error('Failed to save syllabus.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteUnit = async (index) => {
    if (!window.confirm('Are you sure you want to delete this unit?')) return;
    try {
      setIsLoading(true);
      const updatedSyllabus = dynamicSyllabus.filter((_, i) => i !== index);
      const subjectRef = doc(db, 'subjects', subjectKey);
      await setDoc(subjectRef, {
        syllabus: updatedSyllabus,
        updatedAt: new Date()
      }, { merge: true });

      setDynamicSyllabus(updatedSyllabus);
      toast.success('Unit deleted!');
    } catch (error) {
      console.error("Error deleting unit:", error);
      toast.error('Failed to delete unit.');
    } finally {
      setIsLoading(false);
    }
  };

  const openPdfModal = (category, index) => setPdfModal({ isOpen: true, currentIndex: index, category: category.toLowerCase() });
  const closePdfModal = () => setPdfModal({ isOpen: false, currentIndex: 0, category: null });
  const navigatePdf = (direction) => {
    const filteredNotes = filteredNotesByCategory[pdfModal.category] || [];
    let newIndex = direction === 'prev'
      ? (pdfModal.currentIndex === 0 ? filteredNotes.length - 1 : pdfModal.currentIndex - 1)
      : (pdfModal.currentIndex === filteredNotes.length - 1 ? 0 : pdfModal.currentIndex + 1);
    setPdfModal(prev => ({ ...prev, currentIndex: newIndex }));
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, new GoogleAuthProvider());
      setUser(result.user);
      toast.success(`Welcome, ${result.user.displayName}!`);
    } catch (error) { toast.error('Failed to sign in.'); }
  };

  const handleDriveLinkUpload = async (category) => {
    if (!driveLink || !driveTitle) { toast.warning('Title and link are required.'); return; }
    const fileId = extractFileId(driveLink);
    if (!fileId) { toast.warning('Invalid Drive link'); return; }
    const newNote = {
      title: driveTitle,
      category: category.toLowerCase(),
      link: `https://drive.google.com/file/d/${fileId}/view?usp=sharing`,
      directPreviewLink: `https://drive.google.com/file/d/${fileId}/preview`
    };
    try {
      setIsLoading(true);
      const docRef = await addDoc(collection(db, notesCollection), newNote);
      setNotes(prev => [...prev, { ...newNote, id: docRef.id }]);
      cache.clear(notesCollection);
      toast.success('Uploaded!');
      setDriveLink(''); setDriveTitle('');
      setIsLoading(false);
    } catch (error) { toast.error('Error uploading.'); setIsLoading(false); }
  };

  const handleDeleteNote = async (note) => {
    if (window.confirm('Are you sure?')) {
      try {
        setIsLoading(true);
        await deleteDoc(doc(db, notesCollection, note.id));
        setNotes(prev => prev.filter(n => n.id !== note.id));
        cache.clear(notesCollection);
        toast.success('Deleted');
        setIsLoading(false);
      } catch (error) { toast.error('Error deleting.'); setIsLoading(false); }
    }
  };

  const handleRenameNote = (noteId, newTitle) => {
    setNotes(prev => prev.map(n => n.id === noteId ? { ...n, title: newTitle } : n));
    cache.clear(notesCollection);
  };

  const handleAddVideo = async () => {
    if (!videoTitle || !videoUrl) { toast.warning('Title and URL required.'); return; }

    // Robust YouTube URL Formatter
    const formatUrl = (url) => {
      try {
        let videoId = '';
        if (url.includes('youtube.com/playlist?list=')) {
          const playlistId = new URL(url).searchParams.get('list');
          return `https://www.youtube.com/embed/videoseries?list=${playlistId}`;
        }
        if (url.includes('youtu.be/')) {
          videoId = url.split('youtu.be/')[1].split(/[?#]/)[0];
        } else if (url.includes('youtube.com/shorts/')) {
          videoId = url.split('youtube.com/shorts/')[1].split(/[?#]/)[0];
        } else if (url.includes('youtube.com/live/')) {
          videoId = url.split('youtube.com/live/')[1].split(/[?#]/)[0];
        } else if (url.includes('youtube.com/watch?v=')) {
          videoId = new URL(url).searchParams.get('v');
        } else if (url.includes('m.youtube.com/watch?v=')) {
          videoId = new URL(url).searchParams.get('v');
        } else if (url.includes('youtube.com/embed/')) {
          videoId = url.split('youtube.com/embed/')[1].split(/[?#]/)[0];
        }

        if (videoId) return `https://www.youtube.com/embed/${videoId}`;
        return url;
      } catch (e) { return url; }
    };

    const formattedUrl = formatUrl(videoUrl);

    try {
      setIsLoading(true);
      const newVideo = {
        title: videoTitle,
        link: formattedUrl,
        unit: videoUnit,
        isPlaylist: isPlaylist,
        createdAt: new Date()
      };
      const videoRef = await addDoc(collection(db, videosCollection), newVideo);
      setVideos(prev => [...prev, { id: videoRef.id, ...newVideo }]);
      cache.clear(videosCollection);
      setVideoTitle(''); setVideoUrl('');
      setVideoUnit('Unit 1'); setIsPlaylist(false);
      toast.success('Video added!');
      setIsLoading(false);
    } catch (error) { toast.error('Error adding video.'); setIsLoading(false); }
  };

  const handleUpdateVideo = async (videoId, updatedData) => {
    try {
      setIsLoading(true);
      const videoRef = doc(db, videosCollection, videoId);
      await updateDoc(videoRef, {
        ...updatedData,
        updatedAt: new Date()
      });
      setVideos(prev => prev.map(v => v.id === videoId ? { ...v, ...updatedData } : v));
      cache.clear(videosCollection);
      toast.success('Video updated!');
      setIsLoading(false);
    } catch (error) { toast.error('Error updating video.'); setIsLoading(false); }
  };

  const handleDeleteVideo = async (videoId) => {
    if (window.confirm('Delete video?')) {
      try {
        setIsLoading(true);
        await deleteDoc(doc(db, videosCollection, videoId));
        setVideos(prev => prev.filter(v => v.id !== videoId));
        cache.clear(videosCollection);
        toast.success('Deleted');
        setIsLoading(false);
      } catch (error) { toast.error('Error deleting.'); setIsLoading(false); }
    }
  };

  const filteredNotes = pdfModal.category ? filteredNotesByCategory[pdfModal.category] || [] : [];
  const currentPdf = filteredNotes[pdfModal.currentIndex];

  return (
    <div className="min-h-screen transition-colors duration-300" style={{ backgroundColor: c.bg, color: c.text }}>
      <SEO
        title={`${subjectName} Notes, PYQs & Syallbus`}
        description={`Get premium ${subjectName} notes, previous year question papers (PYQs), and detailed syllabus for GGSIPU B.Tech ${branch} ${semester}. Updated for 2024-25 academic session.`}
        keywords={`${subjectName}, ${subjectName} IPU Notes, ${subjectName} PYQ, ${branch} ${semester} Notes, GGSIPU B.Tech ${subjectName}`}
      />
      {/* Top Navigation / Breadcrumbs */}
      <div className="max-w-[1400px] mx-auto px-4 pt-24 md:pt-32 pb-4">
        {/* Back Button */}
        <div style={{ marginBottom: '12px' }}>
          <BackButton
            to={`/btech/${branch.toLowerCase()}/${semester.split(' ')[0].toLowerCase()}`}
            label={`Back to ${branch} ${semester}`}
          />
        </div>

        <nav className="flex items-center gap-2 text-[13px] mb-6 font-medium tracking-tight overflow-x-auto no-scrollbar whitespace-nowrap" style={{ color: c.muted }}>
          <Link to="/" className="hover:text-current transition-colors">Universities</Link>
          <FiChevronRight className="opacity-50 flex-shrink-0" />
          <span className="hover:text-current cursor-pointer flex-shrink-0">GGSIPU</span>
          <FiChevronRight className="opacity-50 flex-shrink-0" />
          <Link to="/btech" className="hover:text-current transition-colors flex-shrink-0">B.Tech</Link>
          <FiChevronRight className="opacity-50 flex-shrink-0" />
          <span className="hover:text-current cursor-pointer flex-shrink-0">{semester}</span>
          <FiChevronRight className="opacity-50 flex-shrink-0" />
          <span className="hover:text-current cursor-pointer flex-shrink-0">{branch}</span>
          <FiChevronRight className="opacity-50 flex-shrink-0" />
          <span className="flex-shrink-0" style={{ color: c.text }}>{subjectName}</span>
        </nav>

        {/* Top Row: Selectors and Subject Picker */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
          <div className="rounded-[2rem] p-8 shadow-2xl transition-colors duration-300" style={{ backgroundColor: c.card, border: `1px solid ${c.glassBorder}` }}>
            <h2 className="text-2xl font-bold mb-8 tracking-tight">B.Tech</h2>
            <div className="space-y-6">
              <div>
                <label className="block text-[11px] font-bold uppercase tracking-widest mb-3" style={{ color: c.muted }}>Semester</label>
                <div className="relative group">
                  <select
                    value={semester}
                    onChange={(e) => {
                      const sem = e.target.value.split(' ')[0].toLowerCase();
                      navigate(`/btech/${branch.toLowerCase()}/${sem}`);
                    }}
                    className="w-full rounded-2xl py-4 px-5 appearance-none text-sm font-medium focus:outline-none focus:ring-2 focus:ring-accent transition-all cursor-pointer"
                    style={{ backgroundColor: c.surface, border: `1px solid ${c.glassBorder}`, color: c.text }}
                  >
                    {['1st Semester', '2nd Semester', '3rd Semester', '4th Semester', '5th Semester', '6th Semester', '7th Semester', '8th Semester'].map(s => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                  <FiChevronDown className="absolute right-5 top-1/2 -translate-y-1/2 transition-colors pointer-events-none" style={{ color: c.muted }} />
                </div>
              </div>
              <div>
                <label className="block text-[11px] font-bold uppercase tracking-widest mb-3" style={{ color: c.muted }}>Branch</label>
                <div className="relative group">
                  <select
                    value={branch}
                    onChange={(e) => {
                      const sem = semester.split(' ')[0].toLowerCase();
                      navigate(`/btech/${e.target.value.toLowerCase()}/${sem}`);
                    }}
                    className="w-full rounded-2xl py-4 px-5 appearance-none text-sm font-medium focus:outline-none focus:ring-2 focus:ring-accent transition-all cursor-pointer"
                    style={{ backgroundColor: c.surface, border: `1px solid ${c.glassBorder}`, color: c.text }}
                  >
                    {['CSE', 'AIML', 'AIDS', 'IT'].map(b => (
                      <option key={b} value={b}>{b}</option>
                    ))}
                  </select>
                  <FiChevronDown className="absolute right-5 top-1/2 -translate-y-1/2 transition-colors pointer-events-none" style={{ color: c.muted }} />
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 rounded-[2rem] p-8 shadow-2xl relative overflow-hidden transition-colors duration-300" style={{ backgroundColor: c.card, border: `1px solid ${c.glassBorder}` }}>
            <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-br from-accent/5 to-transparent pointer-events-none"></div>
            <h2 className="text-2xl font-bold mb-2 tracking-tight">Subjects</h2>
            <p className="text-sm mb-8" style={{ color: c.muted }}>Choose your subject</p>
            <div className="relative group mb-8">
              <div
                className="w-full rounded-2xl py-4 px-6 flex items-center gap-4 cursor-pointer hover:border-current transition-all font-inter"
                style={{ backgroundColor: c.surface, border: `1px solid ${c.glassBorder}` }}
                onClick={() => {
                  const semPrefix = semester.split(' ')[0].toLowerCase();
                  navigate(`/btech/${branch.toLowerCase()}/${semPrefix}`);
                }}
              >
                <FiBook className="text-xl" style={{ color: c.accent }} />
                <span className="text-sm font-semibold">{subjectName}</span>
                <FiChevronDown className="ml-auto transition-colors" style={{ color: c.muted }} />
              </div>
            </div>
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-4 h-4 rounded-full border flex items-center justify-center" style={{ borderColor: c.border }}>
                  <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: c.muted }}></div>
                </div>
                <span className="text-[11px] font-bold uppercase tracking-widest" style={{ color: c.muted }}>Recent Subjects</span>
              </div>
              <div className="flex flex-wrap gap-3">
                <button
                  className="px-5 py-2.5 rounded-full text-xs font-bold transition-all"
                  style={{ backgroundColor: c.surface, border: `1px solid ${c.glassBorder}`, color: c.text }}
                >
                  Applied Mathematics I
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Row */}
        <div className={`grid grid-cols-1 ${activeTab === 'Videos' ? 'lg:grid-cols-1' : 'lg:grid-cols-3'} gap-8 items-start`}>
          <div className={`${activeTab === 'Videos' ? 'lg:col-span-1' : 'lg:col-span-2'} space-y-8`}>
            <div className="rounded-[3rem] p-8 md:p-12 shadow-2xl relative transition-colors duration-300" style={{ backgroundColor: c.card, border: `1px solid ${c.glassBorder}` }}>
              <div className="flex items-center justify-between mb-10">
                <h1 className="text-3xl md:text-4xl font-black tracking-tight">{subjectName}</h1>
                <button className="p-3 transition-colors" style={{ color: c.muted }}>
                  <FiMaximize className="text-xl" />
                </button>
              </div>

              <div className="p-1.5 rounded-2xl flex items-center gap-1 mb-10 overflow-x-auto no-scrollbar" style={{ backgroundColor: c.surface }}>
                {['Theory', 'Notes', 'PYQs', 'Books', 'Videos', 'Practicals'].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`px-8 py-3 rounded-xl text-xs font-black transition-all whitespace-nowrap ${activeTab === tab
                      ? 'shadow-lg'
                      : 'hover:text-current'
                      }`}
                    style={{
                      backgroundColor: activeTab === tab ? c.bg : 'transparent',
                      color: activeTab === tab ? c.text : c.muted
                    }}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              <div className="min-h-[400px]">
                {activeTab === 'Theory' && (
                  <div className="space-y-4">
                    {dynamicSyllabus.map((unit, index) => (
                      <div
                        key={index}
                        className={`group border rounded-3xl overflow-hidden transition-all duration-300 ${expandedUnit === index
                          ? 'shadow-lg'
                          : ''
                          }`}
                        style={{
                          backgroundColor: expandedUnit === index ? 'var(--bg-surface)' : 'var(--bg-main)',
                          borderColor: expandedUnit === index ? 'var(--accent)' : 'var(--border)'
                        }}
                      >
                        <div
                          className="p-3 md:p-4 cursor-pointer flex items-center gap-4 md:gap-6"
                          onClick={() => setExpandedUnit(expandedUnit === index ? null : index)}
                        >
                          <div className={`w-8 h-8 md:w-10 md:h-10 rounded-xl flex items-center justify-center font-black text-xs md:text-sm transition-all ${expandedUnit === index ? 'bg-accent text-white' : ''
                            }`} style={{ backgroundColor: expandedUnit === index ? c.accent : 'rgba(34, 197, 94, 0.1)', color: expandedUnit === index ? '#fff' : c.accent }}>
                            {index + 1}
                          </div>
                          <div className="flex-1 min-w-0">
                            <h3 className="font-bold text-sm md:text-base mb-0.5 md:mb-1 truncate pr-2" style={{ color: c.text }}>{unit.title || `Unit ${index + 1}`}</h3>
                            <p className="text-[10px] md:text-xs font-medium" style={{ color: c.muted }}>
                              {unit.content && typeof unit.content === 'string' ? unit.content.split('\n').filter(l => l.trim()).length : 0} topics
                            </p>
                          </div>
                          <div className="flex items-center gap-3 md:gap-6">
                            {user?.email === adminEmail && (
                              <div className="flex gap-2" onClick={(e) => e.stopPropagation()}>
                                <button
                                  onClick={() => {
                                    setEditingUnitIndex(index);
                                    setEditingUnitData({ title: unit.title, content: unit.content });
                                    setExpandedUnit(null);
                                  }}
                                  className="px-2 py-1 rounded-lg text-[10px] font-bold transition-all"
                                  style={{ color: c.accent, backgroundColor: isDarkMode ? 'rgba(34, 197, 94, 0.1)' : 'rgba(34, 197, 94, 0.05)' }}
                                >
                                  Edit
                                </button>
                                <button
                                  onClick={() => handleDeleteUnit(index)}
                                  className="p-2 text-red-400 rounded-lg transition-all"
                                  style={{ backgroundColor: 'rgba(239, 68, 68, 0.1)' }}
                                >
                                  <FaTrash size={12} />
                                </button>
                              </div>
                            )}
                            <FiChevronDown className={`transition-transform duration-300 ${expandedUnit === index ? 'rotate-180' : ''}`} style={{ color: expandedUnit === index ? c.text : c.muted }} />
                          </div>
                        </div>

                        <AnimatePresence>
                          {expandedUnit === index && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: 'auto', opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3, ease: 'easeInOut' }}
                            >
                              <div className="px-4 md:px-5 pb-4 md:pb-6 pt-1 md:pt-2 border-t" style={{ borderColor: 'var(--border)' }}>
                                <ul className="space-y-3">
                                  {unit.content && typeof unit.content === 'string' ? unit.content.split('\n').filter(l => l.trim()).map((topic, i) => (
                                    <li key={i} className="flex items-start gap-2 p-1.5 md:p-3 rounded-xl transition-colors group/item" style={{ backgroundColor: 'transparent' }}>
                                      <div className="w-1 md:w-1.5 h-1 md:h-1.5 rounded-full mt-1.5 transition-colors" style={{ backgroundColor: 'var(--accent)', opacity: 0.4 }} />
                                      <span className="text-xs md:text-sm transition-colors" style={{ color: 'var(--text-muted)' }}>{topic}</span>
                                    </li>
                                  )) : React.isValidElement(unit.content) ? (
                                    <div className="px-4 py-2">{unit.content}</div>
                                  ) : (
                                    <li className="text-sm italic px-4" style={{ color: 'var(--text-muted)' }}>No topics listed.</li>
                                  )}
                                </ul>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    ))}

                    {user?.email === adminEmail && (
                      <button
                        onClick={() => {
                          setEditingUnitIndex(-1);
                          setEditingUnitData({ title: '', content: '' });
                        }}
                        className="w-full py-4 border-2 border-dashed rounded-3xl transition-all font-bold text-sm"
                        style={{ borderColor: c.glassBorder, color: c.muted }}
                      >
                        + Add New Unit
                      </button>
                    )}

                    {/* Edit Modal / Form for Units */}
                    {(editingUnitIndex !== null) && (
                      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
                        <div className="border rounded-[2rem] p-8 w-full max-w-2xl" style={{ backgroundColor: c.card, borderColor: c.glassBorder }}>
                          <h3 className="text-xl font-bold mb-6" style={{ color: c.text }}>
                            {editingUnitIndex === -1 ? 'Add New Unit' : `Edit Unit ${editingUnitIndex + 1}`}
                          </h3>
                          <div className="space-y-6">
                            <div>
                              <label className="block text-[11px] font-bold uppercase tracking-widest mb-3" style={{ color: c.muted }}>Unit Title</label>
                              <input
                                type="text"
                                value={editingUnitData.title}
                                onChange={(e) => setEditingUnitData({ ...editingUnitData, title: e.target.value })}
                                className="w-full rounded-2xl py-4 px-5 text-sm focus:outline-none focus:ring-2 focus:ring-accent transition-all"
                                style={{ backgroundColor: c.surface, border: `1px solid ${c.glassBorder}`, color: c.text }}
                              />
                            </div>
                            <div>
                              <label className="block text-[11px] font-bold uppercase tracking-widest mb-3" style={{ color: c.muted }}>Topics (one per line)</label>
                              <textarea
                                value={editingUnitData.content}
                                onChange={(e) => setEditingUnitData({ ...editingUnitData, content: e.target.value })}
                                rows={10}
                                className="w-full rounded-2xl py-4 px-5 text-sm focus:outline-none focus:ring-2 focus:ring-accent resize-none transition-all"
                                style={{ backgroundColor: c.surface, border: `1px solid ${c.glassBorder}`, color: c.text }}
                              />
                            </div>
                            <div className="flex gap-4">
                              <button
                                onClick={handleSaveUnit}
                                disabled={isLoading}
                                className="flex-1 py-4 text-white font-black rounded-2xl hover:opacity-90 disabled:opacity-50"
                                style={{ backgroundColor: c.accent }}
                              >
                                {isLoading ? 'Saving...' : 'Save Unit'}
                              </button>
                              <button
                                onClick={() => setEditingUnitIndex(null)}
                                className="flex-1 py-4 font-black rounded-2xl hover:opacity-80 transition-all"
                                style={{ backgroundColor: c.surface, color: c.text, border: `1px solid ${c.glassBorder}` }}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {['Notes', 'PYQs', 'Books', 'Practicals'].includes(activeTab) && (
                  <div className="space-y-6">
                    {user?.email === adminEmail && (
                      <div className="mb-8 p-6 rounded-2xl border" style={{ backgroundColor: c.surface, borderColor: c.glassBorder }}>
                        <h4 className="text-sm font-bold mb-4 uppercase tracking-widest" style={{ color: c.accent }}>Admin: Upload {activeTab}</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                          <input
                            type="text"
                            placeholder="Title"
                            value={driveTitle}
                            onChange={(e) => setDriveTitle(e.target.value)}
                            className="border rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-accent transition-all"
                            style={{ backgroundColor: c.bg, borderColor: c.border, color: c.text }}
                          />
                          <input
                            type="text"
                            placeholder="Drive Link"
                            value={driveLink}
                            onChange={(e) => setDriveLink(e.target.value)}
                            className="border rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-accent transition-all"
                            style={{ backgroundColor: c.bg, borderColor: c.border, color: c.text }}
                          />
                        </div>
                        <button
                          onClick={() => handleDriveLinkUpload(activeTab === 'PYQs' ? 'pyq' : activeTab.toLowerCase())}
                          className="px-6 py-2.5 text-white text-xs font-black rounded-xl transition-all disabled:opacity-50"
                          style={{ backgroundColor: c.accent }}
                          disabled={isLoading}
                        >
                          {isLoading ? 'Uploading...' : `Upload to ${activeTab}`}
                        </button>
                      </div>
                    )}
                    <PdfCards
                      notes={notes.map(n => ({ ...n, _collection: notesCollection }))}
                      category={activeTab === 'PYQs' ? 'pyq' : activeTab.toLowerCase()}
                      onOpenModal={openPdfModal}
                      onDeleteNote={handleDeleteNote}
                      onRenameNote={handleRenameNote}
                      isAdmin={user?.email === adminEmail}
                      renderEmptyState={() => (
                        <div className="text-center py-20 rounded-3xl border" style={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border)' }}>
                          <FiBookOpen className="mx-auto text-4xl mb-4" style={{ color: 'var(--text-muted)' }} />
                          <p className="font-bold uppercase tracking-widest text-xs" style={{ color: 'var(--text-muted)' }}>No {activeTab} available yet</p>
                        </div>
                      )}
                      isLoading={isLoading}
                    />
                  </div>
                )}

                {activeTab === 'Videos' && (
                  <VideoSection
                    videos={videos}
                    videoTitle={videoTitle}
                    videoUrl={videoUrl}
                    videoUnit={videoUnit}
                    isPlaylist={isPlaylist}
                    onVideoTitleChange={(e) => setVideoTitle(e.target.value)}
                    onVideoUrlChange={(e) => setVideoUrl(e.target.value)}
                    onVideoUnitChange={(e) => setVideoUnit(e.target.value)}
                    onIsPlaylistChange={(e) => setIsPlaylist(e.target.checked)}
                    onAddVideo={handleAddVideo}
                    onUpdateVideo={handleUpdateVideo}
                    onDeleteVideo={handleDeleteVideo}
                    isAdmin={user?.email === adminEmail}
                    uploadFormLink={uploadFormLink}
                    subjectKey={subjectKey}
                    isLoading={isLoading}
                  />
                )}

                {!['Theory', 'Notes', 'PYQs', 'Books', 'Videos', 'Practicals'].includes(activeTab) && (
                  <div className="text-center py-20 rounded-3xl border transition-colors duration-300" style={{ backgroundColor: c.surface, borderColor: c.glassBorder }}>
                    <FiBookOpen className="mx-auto text-4xl mb-4" style={{ color: c.muted }} />
                    <p className="font-bold uppercase tracking-widest text-xs" style={{ color: c.muted }}>Content for {activeTab} coming soon</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {activeTab !== 'Videos' && (
            <div className="rounded-[3rem] p-10 shadow-2xl lg:sticky lg:top-32 transition-colors duration-300" style={{ backgroundColor: c.card, border: `1px solid ${c.glassBorder}` }}>
              <div className="flex items-center justify-between mb-10">
                <h2 className="text-xl font-bold tracking-tight">Subject Details</h2>
                {user?.email === adminEmail && (
                  <button
                    onClick={() => {
                      if (isEditingDetails) {
                        handleSaveDetails();
                      } else {
                        setEditingDetails(subjectDetails);
                        setIsEditingDetails(true);
                      }
                    }}
                    className="text-xs font-bold text-green-400 hover:text-green-300 transition-colors"
                  >
                    {isEditingDetails ? 'SAVE' : 'EDIT'}
                  </button>
                )}
              </div>
              <div className="space-y-8">
                {isEditingDetails ? (
                  <div className="space-y-6">
                    {[
                      { key: 'theoryCode', label: 'Theory Code' },
                      { key: 'theoryCredits', label: 'Theory Credits' },
                      { key: 'practicalCode', label: 'Practical Code' },
                      { key: 'practicalCredits', label: 'Practical Credits' }
                    ].map((field) => (
                      <div key={field.key}>
                        <label className="block text-[11px] font-bold uppercase tracking-widest mb-2" style={{ color: c.muted }}>{field.label}</label>
                        <input
                          type="text"
                          value={editingDetails[field.key]}
                          onChange={(e) => setEditingDetails({ ...editingDetails, [field.key]: e.target.value })}
                          className="w-full border rounded-xl py-3 px-4 text-sm focus:outline-none focus:ring-1 focus:ring-accent transition-all"
                          style={{ backgroundColor: c.surface, borderColor: c.glassBorder, color: c.text }}
                        />
                      </div>
                    ))}
                    <button
                      onClick={() => setIsEditingDetails(false)}
                      className="w-full py-3 rounded-xl transition-all"
                      style={{ backgroundColor: c.surface, color: c.text, border: `1px solid ${c.glassBorder}` }}
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  [
                    { label: 'Theory Code', value: subjectDetails.theoryCode },
                    { label: 'Theory Credits', value: subjectDetails.theoryCredits },
                    { label: 'Practical Code', value: subjectDetails.practicalCode },
                    { label: 'Practical Credits', value: subjectDetails.practicalCredits }
                  ].map((detail, i) => (
                    <div key={i} className={`flex items-center justify-between ${i < 3 ? 'pb-6 border-b' : ''}`} style={{ borderColor: c.glassBorder }}>
                      <span className="text-[13px] font-semibold" style={{ color: c.muted }}>{detail.label}</span>
                      <span className="text-[13px] font-black" style={{ color: c.text }}>{detail.value}</span>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <PdfViewerModal
        isOpen={pdfModal.isOpen}
        onClose={closePdfModal}
        currentPdf={currentPdf}
        filteredNotes={filteredNotes}
        currentIndex={pdfModal.currentIndex}
        onNavigate={navigatePdf}
        extractFileId={extractFileId}
      />
    </div>
  );
};

export default SubjectPage;